// Moneda
export const useCurrencyStore = defineStore('currency', () => {
  const currency = useCookie('currency', { default: () => ('EUR'), watch: true })
  /** Ratio moneda → EUR desde `summary.eur_exchange` (api-front). Por defecto 1. */
  const eurExchange = useCookie<number>('eur_exchange', {
    default: () => 1,
    watch: true,
  })

  watch(currency, () => {
    eurExchange.value = 1
  })

  const updateCurrencyByCountry = async (country: string) => {
    currency.value = await getCurrencyByCountry(country)
  }

  const setEurExchange = (value: string | number | null | undefined) => {
    const rate = parseEurExchange(value)
    if (rate == null) return
    eurExchange.value = rate
  }

  /** Ratio para convertir a EUR; si no hay valor de api-front, 1. */
  const getEurExchange = (): number => {
    if (currency.value === 'EUR') return 1
    return parseEurExchange(eurExchange.value) ?? 1
  }

  /** Importe en EUR redondeado para analytics (SalesManago / GTM). */
  const toEurForAnalytics = (amount: number | string | null | undefined): number => {
    return toEurAmountRounded(Number(amount) || 0, getEurExchange())
  }

  return {
    currency,
    eurExchange,
    updateCurrencyByCountry,
    setEurExchange,
    getEurExchange,
    toEurForAnalytics,
  }
})
